import React, { useEffect, useState, useCallback } from 'react'
import { setHeader } from '@/util/set-header'
import { withRouter } from 'react-router'
import { TextareaItem } from 'antd-mobile'
import { ticketCommentApi, ticketAgainApi } from '@/api/repair'
import Star from '@/components/star/star'
import { Toast, Modal } from 'antd-mobile'
import './evaluation.less'
const alert = Modal.alert
function Evaluation({ match, history }: any) {
  const [describe, setDescribe]:any = useState()
  const [star, setStar]:any = useState(0)
  const id = match.params.id
  //返回
  const leftClick = useCallback(() => {
    if (history.length > 1) {
      history.goBack()
    } else {
      if (window.WebViewBridge) {
        window.WebViewBridge.navBackMarket()
      } else if (window.webkit) {
        window.webkit.messageHandlers.navBackMarket.postMessage('')
      }
    }
  }, [history])
  useEffect(() => {
    setHeader({ title: '评价', leftClick })
  }, [leftClick])
  const starChange = (val: number) => {
    setStar(val)
  }
  //输入描述
  const textAreaChange = (value: string | undefined) => {
    setDescribe(value as any)
  }
  //评价和再次保修
  const commentAndAgain = async () => {
    Toast.loading('加载中', 0)
    const { data: againData } = await ticketAgainApi({ id })
    const { data: commentData } = await ticketCommentApi({
      id,
      score: star,
      text: describe,
    })
    Toast.hide()
    if (commentData.code !== 'SUCCESS') {
      Toast.info(commentData.msg)
    } else if (againData.code !== 'SUCCESS') {
      Toast.info(againData.msg, 1.5)
    } else {
      Toast.info('提交成功', 1.5)
    }
    leftClick()
  }
  //评价
  const comment = async () => {
    let params = {
      id,
      score: star,
      text: describe,
    }
    Toast.loading('加载中', 0)
    const { data } = await ticketCommentApi(params)
    Toast.hide()
    if (data.code !== 'SUCCESS') {
      Toast.info(data.msg, 1.5)
      return false
    }
    Toast.info('提交成功', 1.5)
    leftClick()
  }
  //提交操作
  const submit = () => {
    if (star === 0) {
      Toast.info('您还没评级星级', 1.5)
      return
    }
    if (
      star < 3 &&
      (describe === undefined || describe === '' || describe === null)
    ) {
      Toast.info('请输入服务评价', 1.5)
      return
    }
    if (star < 3) {
      alert('是否要重新报修', '', [
        { text: '不需要', onPress: () => comment() },
        { text: '重新报修', onPress: () => commentAndAgain() },
      ])
    } else {
      comment()
    }
  }
  return (
    <div className="repair-evaluation">
      <div className="repair-eval-content">
        <img
          src="/public/assets/img/repairman.png"
          className="repairman-avatar"
          alt=""
        />
        <p className="re-msg">给维修师傅打个分</p>
        <Star onChange={starChange}></Star>
        <p className="re-dsc">请对本次维修评价</p>
        <TextareaItem
          value={describe}
          onChange={textAreaChange}
          className="text-area"
          placeholder="请对本次维修服务评价"
          rows={5}
          count={100}
        />
      </div>

      <div className="repair-eval-but" onClick={submit}>
        提交评价
      </div>
    </div>
  )
}

export default withRouter(Evaluation)
